
export default function Awards() {
  const awards = [
    {
      title: 'UX Certification',
      organization: 'Graphics Guruji',
      year: '2024–2025',
      icon: 'ri-award-line',
      color: 'blue'
    },
    {
      title: 'Turbo Speed Award',
      organization: 'Wipro Technologies (India Meet)',
      year: '2016',
      icon: 'ri-trophy-line',
      color: 'teal'
    }
  ];

  return (
    <section className="py-24 bg-gray-50">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-gray-900 mb-4">Awards & Certifications</h2>
          <div className="w-20 h-1 bg-blue-600 mx-auto"></div>
        </div>

        <div className="grid md:grid-cols-2 gap-8 max-w-4xl mx-auto">
          {awards.map((award, index) => (
            <div key={index} className="bg-white p-8 rounded-2xl shadow-lg hover:shadow-xl transition-all">
              <div className={`w-16 h-16 ${award.color === 'blue' ? 'bg-blue-100' : 'bg-teal-100'} rounded-full flex items-center justify-center mb-4`}>
                <i className={`${award.icon} ${award.color === 'blue' ? 'text-blue-600' : 'text-teal-600'} text-3xl`}></i>
              </div>
              <h3 className="text-2xl font-bold text-gray-900 mb-2">{award.title}</h3>
              <p className="text-gray-600 mb-1">{award.organization}</p>
              <p className="text-sm font-semibold text-blue-600">{award.year}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
